export default {
  getOriginsCategories(state) {
    return state.originsCategories;
  },
  getOriginsCategoriesMap(state) {
    let originsCategoriesMap = {};
    (state.originsCategories || []).forEach((originCategory) => {
      originsCategoriesMap[originCategory.id] = { ...originCategory };
    });
    return originsCategoriesMap;
  },
  getActiveOriginsCategories(state) {
    return state.originsCategories ? state.originsCategories.filter((o) => o.active) : null;
  },
  getActiveCustomOriginsCategories(state) {
    return state.originsCategories ? state.originsCategories.filter((o) => o.active && !o.default) : null;
  },
};
